// DOM Utility functions to replace jQuery
// These functions provide jQuery-like functionality using vanilla JavaScript

// jQuery equivalent: $(selector)
export function $(selector) {
  if (typeof selector === 'string') {
    return document.querySelector(selector)
  }
  return selector
}

// jQuery equivalent: $(selector) - returns all matching elements
export function $$(selector) {
  if (typeof selector === 'string') {
    return document.querySelectorAll(selector)
  }
  return [selector]
}

// jQuery equivalent: $(element).html(content)
export function setHTML(element, content) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.innerHTML = content
  }
}

// jQuery equivalent: $(element).html()
export function getHTML(element) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  return element ? element.innerHTML : ''
}

// jQuery equivalent: $(element).val(value)
export function setVal(element, value) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.value = value
  }
}

// jQuery equivalent: $(element).val()
export function getVal(element) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  return element ? element.value : ''
}

// jQuery equivalent: $(element).css(property, value)
export function setCSS(element, property, value) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.style[property] = value
  }
}

// jQuery equivalent: $(element).on(event, handler)
export function on(element, event, handler) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.addEventListener(event, handler)
  }
}

// jQuery equivalent: $(element).fadeOut(duration)
export function fadeOut(element, duration = 5000) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.style.transition = `opacity ${duration}ms`
    element.style.opacity = '0'
    setTimeout(() => {
      element.style.display = 'none'
    }, duration)
  }
}

// jQuery equivalent: $(element).find(selector)
export function find(element, selector) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  return element ? element.querySelector(selector) : null
}

// jQuery equivalent: $(element).submit()
export function submit(element) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element && element.tagName === 'FORM') {
    element.submit()
  }
}

// jQuery equivalent: $(window).height()
export function windowHeight() {
  return window.innerHeight
}

// Bootstrap 5 modal show/hide functions
export function showModal(element) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element && window.bootstrap) {
    const modal = new window.bootstrap.Modal(element)
    modal.show()
  }
}

export function hideModal(element) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element && window.bootstrap) {
    const modal = window.bootstrap.Modal.getInstance(element)
    if (modal) {
      modal.hide()
    }
  }
}

export function toggleModal(element) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element && window.bootstrap) {
    const modal = window.bootstrap.Modal.getInstance(element) || new window.bootstrap.Modal(element)
    modal.toggle()
  }
}

// Bootstrap modal event listeners
export function onModalShown(element, handler) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.addEventListener('shown.bs.modal', handler)
  }
}

export function onModalHidden(element, handler) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.addEventListener('hidden.bs.modal', handler)
  }
}

export function onModalShow(element, handler) {
  if (typeof element === 'string') {
    element = document.querySelector(element)
  }
  if (element) {
    element.addEventListener('show.bs.modal', handler)
  }
}
